import type { LandingComponents } from "@/puck/blocks/blockTypes";
import { createColumnsBlockConfig } from "@/puck/blocks/shared/columnsBlockConfig";

export const columnsConfigs: Pick<LandingComponents, "Columns"> = {
  Columns: createColumnsBlockConfig({
    blockName: "Columns",
    label: "Columns",
    variant: "landing",
    withHeader: true,
    defaultColumnCount: 3,
    headerDefaults: {
      eyebrow: "DOES THE WORK, NOT JUST THE TALKING",
      title: "The busywork your team dreads, <em>just done.</em>",
      subtitle:
        "Access Gail's conversational AI agents and the everyday insurance work runs itself, start to finish.",
      headerAlign: "center",
    },
  }) as Pick<LandingComponents, "Columns">["Columns"],
};
